<template>


<div class="container-fluid report-container">
  <!-- Stack the columns on mobile by making one full-width and the other half-width -->
  <div class="row">
       <div class="panel panel-default">
  <div class="panel-body">
    <h1 class="panel-title col-sm-9"> {{ reportObject.name }}
        </h1>

<div class="col-sm-3">
  Year: <multi-select v-model="selectedYear" :options="years" v-on:change="selectYear" :limit="1"/>
    <btn type="primary" @click="downloadXLS()" >Download</btn>
  </div>
  </div>


</div>
  <div class="col-xs-6 col-md-5 column">
       
    <div class="chart-container">
      <div class="chart">
          <canvas id="myChart" ></canvas>
        </div>
      </div>
        <img id="url">
      <entity-filter v-show="!showAdvancedFilter" :data-list="users" 
      :searchable-fields="searchableFields" show-alphabetized-filter="false" 
      :use-group="true" :group-by-options="groupByOptions">
      </entity-filter>

        <generic-table v-show="!showAdvancedFilter" :title-map="titleMap" 
        :table-body="land_cover" :end-point="endPoint" :col-class="colClass">
        </generic-table>
    </div>
      <div  class="col-xs-12 col-md-7 column"> 
        <map-display v-if="true"></map-display>
    </div> 
  </div>
</div>
</template>

<script type="text/javascript">
import { mapState } from 'vuex';
import AdvancedFilter from '../AdvancedFilter';
import EntityFilter from '../EntityFilter';
import GenericTable from '../GenericTable';
import store from '../../store.js';
import { separateGeoJsonLayers } from '../../utils.js';
import advancedSearchResults from '../advancedSearchResult';
import CreateButton from '../CreateButton';
import ActionList from '../ActionList';
import MapDisplay from '../report/MapDisplay';
import Chart from 'chart.js';
import { bus } from '../../main';
import datalabels from 'chartjs-plugin-datalabels';
import { ReportWizard } from '../../api';


Chart.plugins.register(datalabels);

function sumFeatures(features){
  return features.reduce(function(total, feat){
    return total + feat.properties.AREA;
  }, 0);
}

export default {
  data() {
    return {
      selectedYear: [],
      comparedYear: [],
      options: [
        {value: 1, label:'2005'},
        {value: 2, label:'2015'},
      ],
      chart: null,
      titleMap: {
        'name': 'Coverage Type',
        'area': 'Area (m^2)',
      },
      groupByOptions: {},
      endPoint: '',
      searchableFields: ['name'],
      label: 'Loading',
      colClass: "col-sm-5 col-xs-12",
      actions: [
      ]
    };
  },
  computed:{
    ...mapState({
      showAdvancedFilter: state => state.showAdvancedFilter,
      reportObject: state => state.reportObject,
      loading: state => state.loading,
      users: function(state) {
        let users = [];
        if (store.state.users !== null) {
          users = store.state.users;
        }
        return users;
      },
       geoJsonLayers: function(state) {
          return state.geoJsonLayers;
      },
      land_cover: function(state){
       return state.geoJsonLayers.map(function(cover){
            return {
              name: Object.keys(cover)[0],
              area: Number(sumFeatures(Object.values(cover)[0].features)).toFixed(2)
            }
        });
      },
      years: function(state){
        return state.geoJsonObjects.map(function(gjson){
          let year = gjson.label.split('_')[1]
          return {value: year, label: year}
        });
     }
    })
  },
  methods: {
    selectYear: function(year){
      let geoJson = store.state.geoJsonObjects.filter(function(gjson){
        return gjson.label.includes(year);
      })[0];
      store.commit('setGeoJsonObjects', geoJson)
      console.log(geoJson);
      store.commit('setGeoJson', geoJson.geo_json);
            console.log(geoJson.geo_json);

      // store.commit('separateGeoJsonLayers');
      this.chart.data.labels = this.geoJsonLayers.map(function(cover){
                return Object.keys(cover)[0].slice(0, 5)+"...";

              })
      this.chart.data.datasets[0].data = this.geoJsonLayers.map(function(cover){
                    return Number(sumFeatures(Object.values(cover)[0].features)).toFixed(2);
                  })
      this.chart.update();
    },
    compareYear: function(year){

    },
    printChart: function(event){
      var url = this.chart.toBase64Image();
      document.getElementById("url").src=url;
    },
    downloadXLS: async function () {
        let file = null;
        let geoJson = null;
        let label = null;
        let separatedLayers = []
        for (var i = store.state.geoJsonObjects.length - 1; i >= 0; i--) {
            file = store.state.geoJsonObjects[i];
            geoJson = file['geo_json'];
            label = file['label'].split('.')[0];
            let _layer = {}
            _layer[label] = separateGeoJsonLayers(geoJson);
            separatedLayers.push(_layer);
        }
        let response = await ReportWizard.createAreaReport(separatedLayers);
        separatedLayers = [];
    },
  },
  mounted: function(){
      var ctx = document.getElementById('myChart').getContext('2d');
      this.chart = new Chart(ctx, {
          // The type of chart we want to create
          type: 'pie',

          // The data for our dataset
          data: {
              labels: this.geoJsonLayers.map(function(cover){
                return Object.keys(cover)[0].slice(0, 5)+"...";
              }),
              datasets: [{
                  label: "Land Cover",
                  backgroundColor: 'rgb(51, 122, 183)',
                  borderColor: 'rgb(51, 122, 183)',
                  data: this.geoJsonLayers.map(function(cover){
                    // Number.parseFloat(x).toFixed(2)
                    return Number(sumFeatures(Object.values(cover)[0].features)).toFixed(2);
                  }),
              }]
          },
          options: {
          plugins: {
            datalabels: {
              color: 'black',
              rotation: -90,
              anchor: 'start',
              align: 'end'
            }
          },
            responsive: true,
            legend: {
              display: false
            },
            title: {
              display: true,
              text: 'Land Cover vs Area'
            },
            scales: {
              yAxes: [{
                scaleLabel: {
                  display: true,
                  labelString: 'Area (km^2)'
                }
              }],
              xAxes: [{
                scaleLabel: {
                  display: true,
                  labelString: 'Land Cover'
                }
              }]
            }     
          }
      });
      

  },
  components:{
    GenericTable,
    EntityFilter,
    AdvancedFilter,
    advancedSearchResults,
    CreateButton,
    ActionList, 
    MapDisplay
  }
};
</script>
<style lang="scss" scoped>
.create-button-container{
    height:75px;
    width: 140%;
    background-color:white;
    margin-left: -1.5rem;
    padding-left: 26px;
    border-top: 1px solid #cfcfcf;

  }
 .chart{
  margin-top: 10px;
  background-color: white;
  border: 1px solid white;
  color: white;
  width: 100%;
  height: 30%;
 }
 .map{
  height: 100%;
  width: 100%;
  background-color: green;
 }
 .report-container{
  padding-top: 10px;
  width: 100%;
  height: 100vh;
  padding:0px;
  margin: 0px;
 }
 .column{
  height: calc(100% - 90px);
 }
 .report-container > .row{
    height: 90%;
    padding-top: 20px;
    overflow: hidden;
 }
 .report-container button{
  color: black;
 }
 .report-container .panel-title{
    font-size: 25px;
 }
 .report-container .panel-footer{
  text-align: right;
 }
 .page-header{
  background-color: white;
 }


</style>



// WEBPACK FOOTER //
// src/components/report/ReportDisplay.vue